import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';


export interface ProfileCard {
	title: string;
	status?: string;
	antiClock?: boolean;
	profileThumbnail?: string;
	progress?: number;
	contactInfo?: Array<any>;
	shortInfo?: Array<any>;
	designation?: string;
	membersCount?: number;
	workGroupOwnerName?: string;
	workGroupOwnerCount?: number;
	joined?: string;
	experience?: string;
	statusCode?: string | Array<string>;
	isAdmin?: boolean | number;
	skillMPermission?: string ;
}

@Component({
	selector: 'app-profile-card',
	templateUrl: './profile-card.component.html',
	styleUrls: ['./profile-card.component.scss']
})
export class ProfileCardComponent implements OnInit {


	@Input('record') profileCard: ProfileCard;
	@Output() detail: any = new EventEmitter();
	constructor(
		public locale: LocaleService,
		public gfService: GlobalFunctionService
	) { }

	ngOnInit(): void {
	}

	info() {
		if (navigator.onLine) {
			this.detail.emit(true);
		}
	}

}
